<template>
  <div class="col order-1 order-lg-2">
    <div class="row my-4">
      <div class="col-md-6 offset-md-3 bg-light p-5">
        <h1 class="h4 text-center">
          {{ 'Create an account' | translate }}
        </h1>
        <div class="mb-3">
          <label for="inputName" class=""><small>{{ 'Name' | translate }}</small></label>
          <input
            type="text"
            id="inputName"
            class="form-control"
            required=""
            autofocus=""
            v-model="name"
          />
          <InputErrors name="name" :errors="errors"></InputErrors>
        </div>
        <div class="mb-3">
          <label for="inputLastName" class=""><small>{{ 'Last name' | translate }}</small></label>
          <input
            type="text"
            id="inputLastName"
            class="form-control"
            required=""
            autofocus=""
            v-model="lastName"
          />
          <InputErrors name="name" :errors="errors"></InputErrors>
        </div>
        <div class="mb-3">
          <label for="inputEmail" class=""><small>{{ 'Email' | translate }}</small></label>
          <input
            type="email"
            id="inputEmail"
            class="form-control"
            required=""
            autofocus=""
            v-model="email"
          />
          <InputErrors name="email" :errors="errors"></InputErrors>
        </div>
        <div class="mb-3">
          <label for="inputPassword" class="">
            <small>{{ 'Password' | translate }}</small>
          </label>
          <input
            type="password"
            id="inputPassword"
            class="form-control"
            required=""
            v-model="password"
          />
          <InputErrors name="password" :errors="errors"></InputErrors>
        </div>
        
        <div class="mb-3 text-center my-4">

        <button
          class="btn btn-primary"
          @click.prevent="register"
        >
          {{ 'Create an account' | translate }}
        </button>
        </div>
        <div class="text-muted text-center">
        <div class="mt-3">
          <small>
            {{ 'By signing up, you agree to our' | translate }}
            <a href="/terms" target="_blank">{{ 'Terms' | translate }}</a>
            {{ 'and' | translate }}
            <a href="/privacy" target="_blank">
              {{ 'Privacy Policy' | translate }}
            </a>
          </small>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from '../../helpers/api'
import InputErrors from './../components/InputErrors'

export default {
  components: {
    InputErrors,
  },
  data() {
    return {
      name: null,
      lastName: null,
      email: null,
      password: null,
      errors: [],
    }
  },
  computed: {
    firstLecture() {
      return this.$store.state.course.sections[0].lectures[0]
    },
  },
  methods: {
    register() {
      this.errors = []
      this.$api
        .register({
          name: this.name,
          last_name: this.lastName,
          email: this.email,
          password: this.password,
        })
        .then(response => {
          this.$store.commit('login', response.data)
          this.$router.push({
            name: 'lecture',
            params: {
              course: this.$route.params.course,
              lecture: localStorage.getItem(this.$route.params.course) || this.firstLecture.id,
            },
          })
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data.errors
          }
        })
    },
  },
}
</script>
